import React, { useState, useEffect} from 'react';
import {DndContext, DragOverlay,MouseSensor,TouchSensor,useSensor,useSensors} from '@dnd-kit/core';
import {arrayMove, SortableContext,useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';


const Relation = ({contentTypeId, contentSetting, contentValue, setIsDraft}) => {
    const [contentTypes, setContentTypes] = useState()
    const [activeId, setActiveId] = useState(null);

    
    useEffect(() => {
      if(contentValue){
        setContentTypes(contentValue.relations)
      }     
    },[contentValue])
    
    const getPosition = (id) => contentTypes.findIndex(r=>r.id === id);
    const sensors = useSensors(
        useSensor(MouseSensor, {
          // Require the mouse to move by 10 pixels before activating
          activationConstraint: {
            distance: 10,
          },
        }),
        useSensor(TouchSensor, {
          // Press delay of 250ms, with tolerance of 5px of movement
          activationConstraint: {
            delay: 250,
            tolerance: 5,
          },
        }))

        const postContentTypeRelationSortOrder = async (relationId, sortOrder) => {

          var graphql = JSON.stringify({
              query: `mutation ($contentTypeId: Guid, $relationId: Guid, $sortOrder: Long){
                          updateContentTypeRelationSortOrder(contentTypeId:$contentTypeId, relationId:$relationId, sortOrder:$sortOrder) {
                            contentTypeId
                            relationId
                            sortOrder
                          }
                      }`,
              variables: {
                  "contentTypeId": contentTypeId
                  ,"relationId": relationId
                  ,"sortOrder": sortOrder
              }
              
            })
          const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
              method:'POST',
              headers:{
                  'Authorization':'Basic ' + global.config.Editor.authToken
                  ,'Content-Type': 'application/json'
              },
              body: graphql
          })
          .then(response => response.text())
          .then(result => {
              var resultData = JSON.parse(result).data
              //if(resultData.addContentType){
              //    history.push(`/content/${resultData.addContentType.id}`)
              //}
              return 
          })
          .catch(error => console.log('error', error))
          const data = await res
          
          return data
  
      }

      let content

      if(contentTypes){
        content = (
        <DndContext sensors={sensors} onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
            <SortableContext items={contentTypes}>
                {contentTypes.map((r, index) => <SortableItem key={r.id} id={r.id} value={r.contentTypeName} index={index} />)}
            </SortableContext>

            <DragOverlay>
                {activeId ? (
                <div>{activeId}</div> 
                ): null}
            </DragOverlay>
        </DndContext>
        )
      }

    return (
        <>{content}</>
    )

    function handleDragStart(event) {
        let value = contentTypes.find(x => x.id === event.active.id).contentTypeName
        setActiveId(value);
      }

    function handleDragEnd(event) {
        const {active, over} = event;
        try{
            if (active.id !== over.id) {
              const oldIndex = getPosition(active.id);
              const newIndex = getPosition(over.id);
                setContentTypes((contentTypes) => {
                    console.log(oldIndex + " - " + newIndex)
                    return arrayMove(contentTypes, oldIndex, newIndex);
                });
                postContentTypeRelationSortOrder(active.id, newIndex + 1)
            }
        }catch(err){}
    }

    function SortableItem(props) {
      const {attributes,listeners,setNodeRef,transform,transition,} = useSortable({id: props.id, value: props.value, index: props.index});
      const style = {transform: CSS.Transform.toString(transform),transition,};
      
      return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
          {props.value}
        </div>
      );
    }
}

export default Relation
